import styled from 'styled-components';
import { Select } from 'zui/Antd';

// This is a secondary styled Select component
// It can be used for custom dropdowns or selections
const SelectSecondary = styled(Select)`
	// Add your styles here

	.ant-select-selection-item {
		color: ${(props) => props.color || 'inherit'};
		font-weight: ${(props) => props.fontWeight || 400};
	}

	.ant-select-selection-placeholder {
		font-weight: ${(props) => props.fontWeight || 400};
	}

	${(props) =>
		props.hoverable &&
		`&:hover {
			background: #0000000a;
		}`}
`;

export default SelectSecondary;
